import type { MouseEvent } from "react";
import { Link } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { LINKS } from "@/constants";
import type { DealerDeviceTransferNotification } from "@/gql/graphql";
import DataListItemText from "@/components/app/Navigation/GlobalHeader/Notifications/Data/DataListItemText";

type DeviceTransferredToAnotherDealerNotificationProps = {
  data: Pick<DealerDeviceTransferNotification, "model" | "serialNumber">;
};

const DeviceTransferredToAnotherDealerNotification = (
  props: DeviceTransferredToAnotherDealerNotificationProps
) => {
  const { data } = props;
  const { model, serialNumber } = data;
  const { t } = useTranslation();

  const handleSupportClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(LINKS.SUPPORT, "_blank", "noopener,noreferrer");
  };

  return (
    <DataListItemText
      primary={t("notifications.device_transferred_to_another_dealer.title", {
        model: model ?? "",
        serialNumber,
      })}
      secondary={
        <Trans
          i18nKey="notifications.device_transferred_to_another_dealer.description"
          values={{ model: model ?? "", serialNumber }}
          components={[
            <Link
              key="support-link"
              component="button"
              type="button"
              variant="caption"
              sx={{ verticalAlign: "baseline" }}
              onClick={handleSupportClick}
            />,
          ]}
        />
      }
    />
  );
};

export default DeviceTransferredToAnotherDealerNotification;
